__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "lesson_homework_microfront";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hookform/resolvers", "3.10.0", () => (Promise.all([__webpack_require__.e(398), __webpack_require__.e(463)]).then(() => (() => (__webpack_require__(9463))))));
			register("@it-incubator/mdx-components", "0.0.13", () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(288), __webpack_require__.e(289), __webpack_require__.e(671), __webpack_require__.e(123)]).then(() => (() => (__webpack_require__(4288))))));
			register("@it-incubator/ui-kit", "1.0.9", () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(953), __webpack_require__.e(289), __webpack_require__.e(671), __webpack_require__.e(58), __webpack_require__.e(865), __webpack_require__.e(325), __webpack_require__.e(202), __webpack_require__.e(322)]).then(() => (() => (__webpack_require__(1953))))));
			register("@tanstack/react-query", "5.8.1", () => (Promise.all([__webpack_require__.e(984), __webpack_require__.e(58), __webpack_require__.e(504)]).then(() => (() => (__webpack_require__(4984))))));
			register("axios", "1.6.1", () => (Promise.all([__webpack_require__.e(471), __webpack_require__.e(107)]).then(() => (() => (__webpack_require__(2471))))));
			register("html-react-parser", "5.0.6", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(20)]).then(() => (() => (__webpack_require__(513))))));
			register("prismjs", "1.29.0", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(976))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(201), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(9201))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(791), __webpack_require__.e(133)]).then(() => (() => (__webpack_require__(2791))))));
			register("react-hook-form", "7.66.0", () => (Promise.all([__webpack_require__.e(47), __webpack_require__.e(457)]).then(() => (() => (__webpack_require__(9047))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(340), __webpack_require__.e(289), __webpack_require__.e(865), __webpack_require__.e(915)]).then(() => (() => (__webpack_require__(6340))))));
			register("react-router-dom", "6.18.0", () => (Promise.all([__webpack_require__.e(521), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(5521))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(231), __webpack_require__.e(515), __webpack_require__.e(361)]).then(() => (() => (__webpack_require__(1231))))));
			register("react", "18.2.0", () => (__webpack_require__.e(576).then(() => (() => (__webpack_require__(5576))))));
			register("socket.io-client", "4.7.5", () => (__webpack_require__.e(147).then(() => (() => (__webpack_require__(5147))))));
			register("zod", "3.22.4", () => (Promise.all([__webpack_require__.e(290), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(1290))))));
			initExternal(8524);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};